module.exports = __webpack_public_path__ + "static/img/zip.63be6633.png";